import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export type PayAuthRequest =
  | {
      PCD_SIMPLE_FLAG: 'Y';
      PCD_PAY_TYPE: 'card';
    }
  | undefined;

export interface PayAuthResponse {
  PCD_AUTH_KEY: string;
  PCD_PAY_HOST: string;
  PCD_PAY_URL: string;
  return_url: string;
  // 아래의 세개 데이터는 PCD_SIMPLE_FLAG가 Y일 때만 반환됨
  cst_id: string;
  custKey: string;
  AuthKey: string;
}

export const createPayAuth = (reqeust: PayAuthRequest) => {
  return api.post<ApiResponse<PayAuthResponse>>('/pay/auth', reqeust);
};

const usePayAuth = (
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<PayAuthResponse>>,
    AxiosError<ApiErrorResponse>,
    PayAuthRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<PayAuthResponse>>,
  AxiosError<ApiErrorResponse>,
  PayAuthRequest,
  QueryKey
> => {
  return useMutation(createPayAuth, {
    ...options,
  });
};

export default usePayAuth;
